import moment from 'moment';
import { useRouter } from 'next/router';

import { useAppDispatch } from '@/hooks/redux';
import { deleteUserNotification } from '@/redux/alerts/alertSlice';
import { togglePanel } from '@/redux/panel/panelSlice';

import { IAlert } from '../../../redux/alerts/model';
import { cn } from '../../../utils/helper';

interface AlertCardProps {
  data: IAlert;
}

const AlertCard: React.FC<AlertCardProps> = ({ data }) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const handleNotificationClick = () => {
    if (data.url) {
      router.push(data.url);
    }
    dispatch(deleteUserNotification(data.id));
    dispatch(togglePanel(null));
  };

  return (
    <button onClick={handleNotificationClick} className='group rounded pl-[20px] pr-[17px] flex flex-col gap-[6px] pt-4 pb-[30px] dark:bg-jet-black bg-white border border-coal-50 dark:border-coal-250 items-start'>
      <div className={cn(data.seen ? 'bg-primary-grey-600 dark:bg-jet-black-100' : 'bg-primary-blue-400/15 text-primary', 'rounded px-2 transition-all duration-1000 delay-1000')}>
        <p className={cn(!data.seen && 'text-primary', 'text-[11px]/[25px] font-semibold rounded text-center transition-all duration-1000 delay-1000')}>{moment(data.createdAt).fromNow()}</p>
      </div>
      <div className='flex justify-between items-center mt-[9px]'>
        <p className={cn(!data.seen && 'text-primary', 'text-sm font-normal group-hover:text-primary transition-all duration-1000 delay-1000 text-left')}>
          {data.title && <span className='text-sm font-semibold group-hover:text-primary mr-2 text-inherit dark:text-inherit'>{data.title}</span>}
          <span className='text-sm font-normal group-hover:text-primary text-inherit dark:text-inherit'>{data.description}</span>
        </p>
      </div>
    </button>
  );
};
export default AlertCard;
